import { Api } from './js/AppApi';

Api.load();
